export default __webpack_public_path__ + "static/media/pdf.20a57c59.svg";